import { Grid, Typography, TypographyProps, Skeleton } from '@mui/material';
import { ReactNode } from 'react';

export interface LabeledDataRowProps {
  loading?: boolean;
  label?: ReactNode | null;
  labelProps?: Partial<TypographyProps>;
  body?: ReactNode | null;
  bodyProps?: Partial<TypographyProps>;
  labelColumnSize?: number;
}

export const LabeledDataRow = ({
  loading,
  label,
  labelColumnSize = 4,
  labelProps,
  bodyProps,
  body,
}: LabeledDataRowProps) => {
  return (
    <>
      <Grid size={labelColumnSize}>
        <Typography variant="body2" color="textSecondary" {...labelProps}>
          {label || null}
        </Typography>
      </Grid>
      <Grid size={12 - labelColumnSize}>
        <Typography variant="body2" color="textPrimary" {...bodyProps}>
          {loading ? <Skeleton /> : body || null}
        </Typography>
      </Grid>
    </>
  );
};
